import { appendAppLog } from './appLog';
import { desktopBruecke } from './gleis';

/**
 * Den Prüfungsclient beenden — **nur am Rechner**.
 *
 * **Warum es das nur hier gibt.** Am iPad beendet der Prüfer die App über das Betriebssystem,
 * und im geführten Zugriff soll er es gerade nicht können; im Browser schliesst man den Tab.
 * Der Rechner ist der einzige Ort, an dem ein Fenster im Vollbild stehen kann, ohne dass ein
 * Weg hinaus sichtbar wäre — dort fehlte er wirklich (Auftrag des Nutzers, 2026-09-23).
 *
 * ⚠️ **Wer beenden darf, entscheidet nicht diese Datei**, sondern
 * `features/beenden/beendenSperre.ts`. Hier steht nur die Tür, dort das Schloss.
 */

/** Steht ein Weg nach draussen zur Verfügung? Am iPad und im Browser: nein. */
export function kannBeenden(): boolean {
  return desktopBruecke() !== null;
}

/**
 * Macht Schluss.
 *
 * ⚠️ **Die Ablage wird drüben sauber geschlossen** (`desktop/main.cts::before-quit`) — hier
 * steht bewusst kein eigenes Aufräumen: zwei Stellen, die dasselbe zumachen, sind eine zu viel.
 */
export async function beendeApp(): Promise<void> {
  const bruecke = desktopBruecke();
  if (!bruecke) return;
  await appendAppLog('Prüfungsclient wird auf Wunsch beendet.');
  await bruecke.beenden();
}

/**
 * Hört auf den Wunsch der Hülle, beenden zu wollen — Menüeintrag, ⌘Q/Alt+F4 oder der
 * Schliessknopf des Fensters.
 *
 * ⚠️ **Die Hülle hält an dieser Stelle schon an.** Sie fragt hier nach, statt zu beenden; was
 * zurückkommt, ist die Abfrage im Fenster. Ohne einen Hörer geschähe nichts — deshalb hängt
 * ihn `app/App.tsx` und nicht ein Blatt, das erst aufgeht, wenn es zu spät ist.
 */
export function aufBeendenwunsch(hoerer: () => void): () => void {
  const bruecke = desktopBruecke();
  if (!bruecke) return () => undefined;
  return bruecke.aufBeendenwunsch(hoerer);
}

/**
 * Beschriftet das Menü der Hülle in der Sprache der Oberfläche.
 *
 * ⚠️ **Wirft nie.** Ein Menü in der falschen Sprache ist ein Schönheitsfehler; eine Ausnahme
 * beim Start wäre eine leere Oberfläche.
 */
export async function beschrifteMenue(texte: {
  beenden: string;
  datei: string;
  bearbeiten: string;
  ansicht: string;
}): Promise<void> {
  const bruecke = desktopBruecke();
  if (!bruecke) return;
  try {
    await bruecke.menue(texte);
  } catch (fehler) {
    await appendAppLog('Menü liess sich nicht beschriften: ' + String(fehler), 'warn');
  }
}
